export const vsLookupManagementServiceName = "mealLogLookupManagementService";
export const vsLookupManagementServiceProviderName = `${vsLookupManagementServiceName}Provider`;
